<!--suppress ALL -->
<template>
  <g-field :label="label" :type="type" :message="message">
    <g-field is-grouped>
      <g-select @input="onSelected" is-fullwidth :value="value || ''"
                :placeholder="isLoading ? $t('text.loading') : 
                (categories.length === 0 ? $t('text.no_content_loaded') : placeholder)" 
                class="control is-expanded" :disabled="disabled || isLoading">
        <option v-for="category in categories"
                :value="category.id" :key="category.id">
          {{ category.name }}
        </option>
      </g-select>

      <div v-if="isLoading" class="control">
        <g-button type="light">
          <span class="icon">
            <i class="fas fa-spinner fa-spin"></i>
          </span>
        </g-button>
      </div>
    </g-field>
  </g-field>
</template>

<script lang="ts">
import { Component, Vue, Prop, Container } from 'annotation';
import {cloneDeep} from 'lodash';
import CashierCategory from "../../../entity/CashierCategory";
import CashierService from "../../../service/CashierService";
import Response from "../../../service/Response";

@Component
export default class KategoriProdukSelect extends Vue {

  @Prop({default: null, type: Number})
  public value: number;

  @Prop({default: "Kategori", type: String})
  public label: string;

  @Prop({default: "Pilih kategori", type: String})
  public placeholder: string;

  @Prop({type: String, default: null})
  public type: any;

  @Prop({type: String, default: null})
  public message: any;

  @Prop({default: false, type: Boolean})
  public disabled: boolean;

  public get cashierService(): CashierService {
    return Container.get(CashierService);
  }

  public isLoading: boolean = false;

  public categories: Array<CashierCategory> = [];

  public async mounted() {
    await this.loadCategories();
  }

  public async loadCategories() {
    this.isLoading = true;
    const merchantKode = this.$route.query.merchant_kode as string || 'SALWA';
    const response: Response = await this.cashierService.findCategories({
      merchant_kode: merchantKode,
      is_active: true
    });
    
    if (response.isSuccess) {
      this.categories = response.getDeserializeResponse([], CashierCategory);
    }
    this.isLoading = false;
  }

  public onSelected(categoryId: number) {
    const category: CashierCategory = this.categories.find((item: CashierCategory) => item.id === categoryId) ||
        new CashierCategory();

    this.$emit('input', categoryId);
    this.$emit('category-selected', cloneDeep(category));
  }

}
</script>

